import React from "react";
import LoginForm from "../components/auth/LoginForm";
import { Helmet } from "react-helmet";

const Login = () => {
  return (
    <div
      style={{
        backgroundImage: `linear-gradient(135deg, rgba(0, 255, 60, 0.3) , rgba(0, 157, 255, 0.3))`,
        minHeight: "90vh",
      }}
    >
      <Helmet>
        <title>LoginPage | Blogia</title>
        <meta name="description" content="LoginPage description" />
      </Helmet>
      <LoginForm />
    </div>
  );
};

export default Login;
